// extracted by mini-css-extract-plugin
module.exports = {"rules__title":"rules__title-13YLz","rules__text":"rules__text-3h0Jy","rules__label":"rules__label-1e34M","rules__checkbox":"rules__checkbox-3hriF"};